import Auth from './Auth'
import { Route, Switch } from 'react-router'
import { 
    CartList, OrderConfirm, OrderComplete, OrderHistory, MyPage, CheckoutWrapper,
    ProductEdit, ProductDetail, ProductList, ReviewEdit,
    NewsDetail, NewsList, NewsEdit, MagazineDetail, MagazineList, MagazineEdit,
    BrandRzeus, PreOrderComplete,
    Reset, SignIn, SignUp, SignUpComplete,
    Top, Contact, ContactComplete, About, PrivacyPolicy, TradeLaw, Company,
    Profile, ProfileEdit, Subscription, EmailChange, PasswordChange, Delete, 
    ContactManager, ContactDetail, OrderManager, OrderDetail, CustomerManager, CustomerDetail, SalesManager, 
    NewsManager, MagazineManager, ProductManager
} from './templates'
import { useSelector } from 'react-redux'
import { getRole } from './reducks/users/selectors'


const Router = () => {

    const selector = useSelector(state => state)
    const role = getRole(selector)

    return (
        <Switch>
            <Route exact path={"/signin"} component={SignIn}/>
            <Route exact path={"/signin/reset"} component={Reset}/>
            <Route exact path={"/signup"} component={SignUp}/>
            <Route exact path={"/signup/complete"} component={SignUpComplete}/>

            <Auth>
                <Route exact path={"/about"} component={About}/>
                <Route exact path={"/contact"} component={Contact}/>
                <Route exact path={"/contact/complete"} component={ContactComplete}/>
                <Route exact path={"/company"} component={Company}/>
                <Route exact path={"/privacypolicy"} component={PrivacyPolicy}/>
                <Route exact path={"/tradelaw"} component={TradeLaw}/>

                <Route exact path={"/product"} component={ProductList}/>
                <Route exact path={"/product/dp/:id"} component={ProductDetail} />
                <Route exact path={"/news"} component={NewsList}/>
                <Route exact path={"/news/dp/:id"} component={NewsDetail}/>
                <Route exact path={"/magazine"} component={MagazineList}/>
                <Route exact path={"/magazine/dp/:id"} component={MagazineDetail}/>

                <Route exact path={"/brand/rzeus"} component={BrandRzeus}/>
                <Route exact path={"/brand/rzeus/complete"} component={PreOrderComplete}/>

                <Route exact path={"(/)?"} component={Top}/>
            
                {/* 注文 */}
                <Route exact path={"/cart"} component={CartList}/>
                <Route exact path={"/order/confirm"} component={OrderConfirm}/>
                <Route exact path={"/order/complete"} component={OrderComplete}/>
                <Route exact path={"/payment/edit"} component={CheckoutWrapper}/>
                <Route exact path="/product/reviewedit/:id" component={ReviewEdit} />
                
                {/* マイページ */}
                <Route exact path={"/mypage"} component={MyPage}/>
                <Route exact path={"/order/history"} component={OrderHistory}/>
                <Route exact path={"/profile"} component={Profile}/>
                <Route exact path={"/profile/edit"} component={ProfileEdit}/>
                <Route exact path={"/subscription"} component={Subscription}/>
                <Route exact path={"/emailchange"} component={EmailChange}/>
                <Route exact path={"/passwordchange"} component={PasswordChange}/>
                <Route exact path={"/delete"} component={Delete}/>

                {/* 管理者用 */}
                {role === "admin" && (
                <>
                    <Route path="/product/edit(/:id)?" component={ProductEdit} />
                    <Route path="/news/edit(/:id)?" component={NewsEdit}/>
                    <Route path="/magazine/edit(/:id)?" component={MagazineEdit}/>
                    <Route exact path={"/admin/contact"} component={ContactManager}/>
                    <Route exact path={"/admin/contact/dp/:id"} component={ContactDetail}/>
                    <Route exact path={"/admin/order"} component={OrderManager}/>
                    <Route exact path={"/admin/order/dp/:id"} component={OrderDetail}/>
                    <Route exact path={"/admin/customer"} component={CustomerManager}/>
                    <Route exact path={"/admin/customer/dp/:id"} component={CustomerDetail}/>
                    <Route exact path={"/admin/sales"} component={SalesManager}/>
                    <Route exact path={"/admin/news"} component={NewsManager}/>
                    <Route exact path={"/admin/magazine"} component={MagazineManager}/>
                    <Route exact path={"/admin/product"} component={ProductManager}/>
                </>
                )}

            </Auth>
        </Switch>
    )
}

export default Router